import React, { useState, useRef, useEffect } from 'react';
import { User, Lock, LogOut, ChevronDown, Shield } from 'lucide-react';

const ProfileDropdown = ({ userProfile, onOpenModal, handleLogout }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen(!isOpen);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const getInitials = (name) => {
        if (!name) return 'U';
        return name.substring(0, 2).toUpperCase();
    };

    const containerStyle = {
        position: 'relative',
        display: 'inline-block',
    };

    const buttonStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '4px',
        borderRadius: '24px',
        transition: '0.2s',
    };

    const avatarStyle = {
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundColor: '#ee4d2d',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: '14px',
        border: '2px solid #fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    };

    const menuStyle = {
        position: 'absolute',
        top: '110%',
        right: 0,
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
        minWidth: '200px',
        padding: '8px',
        zIndex: 1000,
        border: '1px solid #e2e8f0',
        display: isOpen ? 'block' : 'none'
    };

    const itemStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        width: '100%',
        padding: '10px 12px',
        border: 'none',
        background: 'transparent',
        textAlign: 'left',
        cursor: 'pointer',
        borderRadius: '6px',
        color: '#334155',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'background 0.2s'
    };

    const handleMenuClick = (action) => {
        setIsOpen(false);
        if (action === 'logout') {
            handleLogout();
        } else {
            onOpenModal(action);
        }
    };

    return (
        <div style={containerStyle} ref={dropdownRef}>
            <button style={buttonStyle} onClick={toggleDropdown} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                <div style={avatarStyle}>
                    {getInitials(userProfile?.name || userProfile?.username)}
                </div>
                <ChevronDown size={16} color="#64748b" />
            </button>

            <div style={menuStyle}>
                <div style={{ padding: '8px 12px', borderBottom: '1px solid #f1f5f9', marginBottom: '4px' }}>
                    <div style={{ fontWeight: 'bold', color: '#1e293b', fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {userProfile?.name || userProfile?.username || 'Usuário'}
                    </div>
                    <div style={{ color: '#94a3b8', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {userProfile?.email}
                    </div>
                </div>

                <button 
                    style={itemStyle} 
                    onClick={() => handleMenuClick('data')}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    <User size={16} color="#64748b" /> Meus Dados
                </button>
                <button 
                    style={itemStyle} 
                    onClick={() => handleMenuClick('password')}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    <Lock size={16} color="#64748b" /> Alterar Senha
                </button>
                {['admin', 'moderator', 'support'].includes(userProfile?.role) && (
                    <button 
                        style={{ ...itemStyle, color: '#9333ea', fontWeight: '600' }} 
                        onClick={() => window.location.href = '/admin'}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#faf5ff'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <Shield size={16} color="#9333ea" /> Painel Admin
                    </button>
                )}
                <div style={{ borderTop: '1px solid #f1f5f9', margin: '4px 0' }} />
                <button 
                    style={{ ...itemStyle, color: '#ef4444' }} 
                    onClick={() => handleMenuClick('logout')}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    <LogOut size={16} color="#ef4444" /> Sair
                </button>
            </div>
        </div>
    );
};

export default ProfileDropdown;
